import Stack from "@mui/material/Stack";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


import ControllerTable from "./ControllerTable";
import FacilityForm from "./FacilityForm";
import TariffTable from "./TariffTable";
import FacilityThumbnailForm from "./FacilityThumbnailForm";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import FloorPlanEditor from "./FloorPlanEditor";
import CreateNewFacility from "./CreateNewFacility";

function FacilityEdit({  facility }) {

    const { t } = useTranslation();

	return (
		<Stack spacing={3}>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("General")}
                        </Typography>
                        <FacilityForm
                            facility={facility}
                        />
                    </Stack>
                </CardContent>
            </Card>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("Controllers")}
                        </Typography>
                        <ControllerTable
                            facility={facility}
                        />
                    </Stack>
                </CardContent>
            </Card>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("Tariffs")}
                        </Typography>
                        <TariffTable
                            facility={facility}
                        />
                    </Stack>
                </CardContent>
            </Card>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("Floor plans")}
                        </Typography>
                        <FloorPlanEditor facility={facility}/>
                    </Stack>
                </CardContent>
            </Card>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("Thumbnail")}
                        </Typography>
                        <FacilityThumbnailForm
                            facility={facility}
                        />
                    </Stack>
                </CardContent>
            </Card>
            { ((new URLSearchParams(window.location.search)).get("staff") === "true") &&
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("Create new facility")}
                        </Typography>
                        <CreateNewFacility/>
                    </Stack>
                </CardContent>
            </Card>
            }
		</Stack>
	);
}

export default FacilityEdit;
